import { COMMISSION_RUN_STATUSES, type CommissionRunStatus } from '@sahab/contracts'
import { z } from 'zod'

export const PAGE_SIZES = [25, 50, 100] as const

const pageSize = z
  .number()
  .refine((n): n is (typeof PAGE_SIZES)[number] => (PAGE_SIZES as readonly number[]).includes(n))
  .optional()
  .catch(undefined)

const page = z.number().int().min(1).optional().catch(undefined)

/** The commission runs list in the URL: status, year and page (newest month first). */
export const commissionRunSearchSchema = z.object({
  page,
  pageSize,
  status: z.enum(COMMISSION_RUN_STATUSES).optional().catch(undefined),
  year: z.number().int().min(2000).max(2100).optional().catch(undefined),
})
export type CommissionRunSearch = z.infer<typeof commissionRunSearchSchema>

export interface RunListParams {
  page: number
  pageSize: number
  sort: string
  status: CommissionRunStatus | undefined
  year: number | undefined
}

export function toRunListQuery(search: CommissionRunSearch): RunListParams {
  return {
    page: search.page ?? 1,
    pageSize: search.pageSize ?? PAGE_SIZES[0],
    sort: '-period',
    status: search.status,
    year: search.year,
  }
}

export const PLAN_TABS = ['plan', 'members'] as const
export type PlanTab = (typeof PLAN_TABS)[number]

/** A plan's page: the open tab (the plan's terms, or its members). */
export const planPageSearchSchema = z.object({
  tab: z.enum(PLAN_TABS).optional().catch(undefined),
})
export type PlanPageSearch = z.infer<typeof planPageSearchSchema>

/** A run's statements: their page. */
export const runPageSearchSchema = z.object({ page })
export type CommissionRunPageSearch = z.infer<typeof runPageSearchSchema>
